import * as Types from './types'
import { fetchProduct, fetchProducts } from './fetch_products'

import { createCart } from '../storefront_client/create_cart'
import { fetchCart } from '../storefront_client/fetch_cart'
import { updateCart } from '../storefront_client/update_cart'
import { addVariantToCart } from '../storefront_client/add_variant_to_cart'
import { removeFromCart } from '../storefront_client/remove_from_cart'
import { updateItemQuantity } from '../storefront_client/update_item_quantity'

export * from './types'

export const DEFAULT_IMAGE: Types.IImage = {
  src: '',
  altText: 'Missing image',
}

export class ShopifyClient {
  fetchCart = fetchCart
  createCart = createCart
  updateCart = updateCart
  addVariantToCart = addVariantToCart
  removeFromCart = removeFromCart
  updateItemQuantity = updateItemQuantity
  fetchProduct = fetchProduct
  fetchProducts = fetchProducts
}

export {
  fetchProduct,
  fetchProducts,
}
